import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader, EmptyState } from '@/components/ui-bits';
import { Key, Plus, Trash2, Globe, Copy, Check, Shield, Power } from 'lucide-react';
import { toast } from 'sonner';

export default function ApiKeysPage() {
  const [keys, setKeys] = useState([]);
  const [domains, setDomains] = useState([]);
  const [tenant, setTenant] = useState(null);
  const [name, setName] = useState('');
  const [dom, setDom] = useState('');
  const [reveal, setReveal] = useState(null);
  const load = async () => {
    const [k, d, s] = await Promise.all([
      api.get('/admin/api-keys'),
      api.get('/admin/whitelist'),
      api.get('/admin/settings'),
    ]);
    setKeys(k.data.keys); setDomains(d.data.domains); setTenant(s.data.tenant);
  };
  useEffect(() => { load(); }, []);
  const create = async () => {
    if (!name.trim()) return;
    const { data } = await api.post('/admin/api-keys', { name });
    setName(''); setReveal(data.api_key); load();
    toast.success('API key creada. Cópiala ahora — no se mostrará de nuevo.');
  };
  const revoke = async (k) => { if (!confirm(`Revocar "${k.name}"?`)) return; await api.delete(`/admin/api-keys/${k.id}`); load(); };
  const addDom = async () => { if (!dom.trim()) return; await api.post('/admin/whitelist', { domain: dom }); setDom(''); load(); toast.success('Dominio agregado'); };
  const delDom = async (d) => { await api.delete(`/admin/whitelist/${d.id}`); load(); };
  const toggleEnforce = async () => {
    await api.patch('/admin/settings', { enforce_domain_whitelist: !tenant.settings?.enforce_domain_whitelist });
    load(); toast.success('Configuración actualizada');
  };
  const copy = (t) => { navigator.clipboard.writeText(t); toast.success('Copiado'); };

  return (
    <div>
      <PageHeader title="API Keys & Dominios" description="Llaves de tu API y whitelist de dominios autorizados." />
      <div className="grid lg:grid-cols-2 gap-4">
        <div className="surface p-5">
          <h2 className="font-display font-semibold flex items-center gap-2"><Key className="h-4 w-4" /> API Keys</h2>
          <p className="text-xs text-muted-foreground mt-1">Usa el header <span className="font-mono">X-API-Key</span> en /api/v1/leads</p>
          <div className="mt-3 flex gap-2"><input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre (Landing, Mobile, etc)" className="input" /><button data-testid="apikey-create" onClick={create} className="btn-primary"><Plus className="h-4 w-4" /> Crear</button></div>
          {reveal && (
            <div className="mt-3 surface p-3 border border-[hsl(var(--warning))]/40 bg-[hsl(var(--warning))]/5">
              <div className="text-xs font-medium mb-1">Tu nueva API Key (única visualización):</div>
              <div className="flex items-center gap-2"><code className="flex-1 font-mono text-xs break-all">{reveal.key}</code><button onClick={() => copy(reveal.key)} className="btn-ghost h-7 w-7 p-0"><Copy className="h-3 w-3" /></button></div>
            </div>
          )}
          <div className="mt-4 space-y-2">
            {keys.length === 0 && <div className="text-sm text-muted-foreground">Sin keys.</div>}
            {keys.map((k) => (
              <div key={k.id} className="flex items-center gap-2 p-2 border border-border rounded-[10px]">
                <div className="flex-1">
                  <div className="text-sm font-medium">{k.name}</div>
                  <div className="text-xs text-muted-foreground font-mono">{k.key.slice(0, 8)}…{k.key.slice(-6)}</div>
                </div>
                <button onClick={() => revoke(k)} className="btn-ghost h-7 w-7 p-0 text-[hsl(var(--danger))]"><Trash2 className="h-4 w-4" /></button>
              </div>
            ))}
          </div>
        </div>
        <div className="surface p-5">
          <div className="flex items-center justify-between">
            <h2 className="font-display font-semibold flex items-center gap-2"><Globe className="h-4 w-4" /> Dominios autorizados</h2>
            <label className="flex items-center gap-2 text-xs">
              <input data-testid="enforce-whitelist" type="checkbox" checked={!!tenant?.settings?.enforce_domain_whitelist} onChange={toggleEnforce} />
              Aplicar whitelist
            </label>
          </div>
          <p className="text-xs text-muted-foreground mt-1">Cuando esté activado, solo se aceptarán peticiones desde estos dominios (en la API pública y formularios).</p>
          <div className="mt-3 flex gap-2"><input value={dom} onChange={(e) => setDom(e.target.value)} placeholder="landing.miempresa.com" className="input" /><button data-testid="domain-add" onClick={addDom} className="btn-primary"><Plus className="h-4 w-4" /> Agregar</button></div>
          <div className="mt-3 space-y-2">
            {domains.length === 0 && <div className="text-sm text-muted-foreground">Sin dominios.</div>}
            {domains.map((d) => (
              <div key={d.id} className="flex items-center gap-2 p-2 border border-border rounded-[10px]">
                <span className="flex-1 font-mono text-sm">{d.domain}</span>
                <button onClick={() => delDom(d)} className="btn-ghost h-7 w-7 p-0 text-[hsl(var(--danger))]"><Trash2 className="h-4 w-4" /></button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
